import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Ship, ShipService } from '../../services/ship.service';
import { EmployeeService } from '../../services/employee.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-ship',
  templateUrl: './create-ship.component.html',
  styleUrls: ['./create-ship.component.css']
})
export class CreateShipComponent implements OnInit {

  shipForm: FormGroup;

  employees = {};
  subsidiaries = {};

  employeesInit: any;
  subsidiariesInit: any;

  subs: Subscription[] = [];

  constructor(
    private shipService: ShipService,
    private employeeService: EmployeeService,
    private subsidiaryService: SubsidiaryService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.employeeService.getEmployees().subscribe(employees => {
        const data = employees.reduce((acc, cur) => {
          acc[`${cur.name.trim()} ${cur.lastName.trim()}`] = null;
          this.employees[`${cur.name.trim()} ${cur.lastName.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.employeesInit = { 'data': data };
      })
    );
    this.subs.push(
      this.subsidiaryService.getSubsidiaries().subscribe(subsidiaries => {
        const data = subsidiaries.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.subsidiaries[`${cur.name.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.subsidiariesInit = { 'data': data };
      })
    );
  }

  createForm() {
    this.shipForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      lines: '',
      sizeHa: ['', Validators.required],
      supervisorId: ['', Validators.required],
      subsidiaryId: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.supervisorId = this.employees[value.supervisorId];
    value.subsidiaryId = this.subsidiaries[value.subsidiaryId];
    this.shipService.addShip(value);
  }

  get supError(){ return !this.employees[this.shipForm.get('supervisorId').value] }
  get subError(){ return !this.subsidiaries[this.shipForm.get('subsidiaryId').value] }
}
